import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_snack_1: FaireProductEntity = {
  token: "nyc-snack-1",
  type: "product",
  name: "Creamy Pistachio Spread",
  brandName: "Oskrö",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/92f1720de98adede92a4e1ce7abff38652be4359bc4363a724996e08cb676bc0.webp",
  priceDollars: 14.5,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/92f1720de98adede92a4e1ce7abff38652be4359bc4363a724996e08cb676bc0.webp",
  weight: 0.6,
  dimensions: {
    width: 3,
    height: 4,
    depth: 3,
  },
  description: "Premium pistachio spread perfect for breakfast or snacking",
  categoryTokens: ["cat_food-snacks"],
  tags: ["nyc-local", "premium", "artisanal", "spreads"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
